import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NewOnboardingTemplate = () => {
  const navigate = useNavigate();
  const [radioValue, setRadioValue] = useState("scratch");
  const [onboardingTemplates, setOnboardingTemplates] = useState([]);
  const [templateId, setTemplateId] = useState(0);
  const [templateName, setTemplateName] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchOnboardingTemplates();
  }, []);

  async function fetchOnboardingTemplates() {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      searchkey: "",
    };
    await ApiHelper.post(API.getSectionTemplates, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setOnboardingTemplates(resData?.data?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }

  const saveSectionTemplate = async () => {
    if (templateName !== "") {
      setLoader(true);
      let user = JSON.parse(localStorage.getItem("UserData"));
      const formData = {
        userid: user?.id,
        template_name: templateName,
        templateid: templateId,
      };
      await ApiHelper.post(API.createSectionTemplates, formData)
        .then((resData) => {
          console.log(resData);
          if (resData.data.success === true) {
            navigate("/dashboard/onboarding/edit-onboarding-template");
            localStorage.setItem(
              "Tempdata",
              JSON?.stringify(resData?.data?.templateData[0])
            );
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      toast("Template name cannot be empty!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <div className=" sidebar_open">
      <div className="new-temp-onbord-main my-3 py-5 px-4 createBg ">
        <div className="create-process  ">
          <div className="wraper mt-2 mb-2">
            <h6 className="subTitle">Setup your Onboarding Process.</h6>
            <div className="card-cprocess ">
              <div className="card-header-cp border-bottom-0">
                <h3 className="card-title-cp">Create Process</h3>
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="pro-title mb-2">Process Title</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setTemplateName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8 tmpRadio mt-3">
                      <input
                        type="radio"
                        name="from"
                        value="scratch"
                        checked={radioValue === "scratch"}
                        className="proc-radio"
                        onChange={(e) => {
                          setRadioValue(e.target.value);
                        }}
                      />
                      <label className="pro-title">From Scratch</label>
                      <input
                        type="radio"
                        name="from"
                        value="template"
                        checked={radioValue === "template"}
                        className="proc-radio"
                        onChange={(e) => {
                          setRadioValue(e.target.value);
                        }}
                      />
                      <label className="pro-title">Use Existing Process</label>
                    </div>

                    {radioValue === "template" && (
                      <div className="col-md-12 mt-3">
                        <div className="form-group">
                          <label className="pro-title mb-2">
                            Select Process
                          </label>
                          <select
                            className="procc-selet"
                            onChange={(e) => {
                              setTemplateId(e.target.value);
                            }}
                          >
                            <option value="0">Select</option>
                            {onboardingTemplates.map((item) => {
                              return (
                                <option value={item?.id}>
                                  {item?.template_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="form-group mt-4 mb-0">
                      <button
                        type="button"
                        className="btn btn-primary btn_wid btn-check-and-submit"
                        onClick={saveSectionTemplate}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loader && <Spinner />}
    </div>
  );
};

export default NewOnboardingTemplate;
